import React, { useState, useEffect } from 'react';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { useGetAll } from '../hooks/SIMchange';
import { CreateModal } from '../_modals/CreateModal';
import {
  formatDateMonth,
  formatPhoneNumber,
  KTSVG,
  LoadingGrid,
} from '../../../../_mexablock/helpers';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');

  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [initFilterValues] = useState({
    nombre: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const openModal = () => setVisivilityModal(true);
  const closeModal = (updateGrid: boolean) => {
    if (updateGrid) setReloadGrid(Math.random() * 40);
    setVisivilityModal(false);
  };

  const columns: any = [
    {
      id: 'created_at',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },
    {
      id: 'prev_iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID Ant.</div>,
      selector: (row: any) => row.prev_iccid,
      sortable: true,
      width: '185px',
    },
    {
      id: 'new_iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID Act.</div>,
      selector: (row: any) => row.new_iccid,
      sortable: true,
      width: '185px',
    },
    {
      id: 'msisdn',
      name: <div className="fw-bolder text-muted me-5">Número</div>,
      selector: (row: any) => formatPhoneNumber(row.msisdn),
      sortable: true,
    },

    {
      id: 'customer.first_name',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) =>
        row.customer
          ? `${row.customer?.first_name} ${row.customer?.father_last_name}`
          : 'Sin cliente',
      sortable: true,
    },

    {
      id: 'customer.creator',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        row.creator
          ? `${row.creator?.first_name} ${row.creator?.father_last_name}`
          : 'Sin usuario',

      sortable: true,
    },
  ];

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              {/* <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={onCleanFilter}
                onSearchFilter={onSearchFilter}
              /> */}
              <div className="card-title align-items-start flex-column"></div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  className="btn btn-sm btn-light-primary"
                  id="kt_toolbar_primary_button"
                  onClick={openModal}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Cambiar SIM
                </a>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <CreateModal
        id_row={0}
        title="Cambio de SIM"
        show={visivilityModal}
        handleClose={closeModal}
      />
    </>
  );
};

export { View };
